import React from 'react';
import { Card } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import { AreaChart } from '../charts';
import { ThemeColors } from '../../../../../helpers/ThemeColors';
const colors = ThemeColors();

const VoucherEngineShare = ({ labels, data, currency
}) => {
    console.log(data);
    const datasets = data.filter(f=>f.type==="Clicks").map(elem => elem.stats);
    const secondDataset = data.filter(f=>f.type==="Share").map(elem => elem.stats);
    const areaChartData = {
        labels,
        datasets: [
            {
                label: 'Clicks',
                data: datasets,
                borderColor: '#EF4A81',
                pointBackgroundColor: '#EF4A81',
                pointBorderColor: '#EF4A81',
                pointHoverBackgroundColor:'#EF4A81',
                pointHoverBorderColor: '#EF4A81',
                pointRadius: 4,
                pointBorderWidth: 2,
                pointHoverRadius: 5,
                fill: false,
                borderWidth: 2,
                backgroundColor: '#EF4A81',
            },
            {
                label: 'Share',
                data: secondDataset,
                borderColor: '#3582b3',
                pointBackgroundColor: '#3582b3',
                pointBorderColor: '#3582b3',
                pointHoverBackgroundColor:'#3582b3',
                pointHoverBorderColor: '#3582b3',
                pointRadius: 4,
                pointBorderWidth: 2,
                pointHoverRadius: 5,
                fill: true,
                borderWidth: 2,
                backgroundColor: '#3582b3',
            },
        ],
    };
    return (
        <Card className={`dashboard-filled-line-chart`}>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline">
                            Social Share
                        </h5>
                        <span className="text-muted text-small d-block">
                        </span>
                    </div>
                </div>
            </div>

            <div className="chart card-body pt-0">
                <AreaChart shadow data={areaChartData} />
            </div>
        </Card>
    );
};

export default VoucherEngineShare;
